import Script from 'next/script'

import { GoogleTagManager } from '@next/third-parties/google'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/next'

import { readEffectiveConsent } from '@ui/lib/consent'

const BRANCH_KEY = process.env.NEXT_PUBLIC_BRANCH_KEY

// Every Vercel deploy loads the published container; local runs load nothing.
// Which GA4 property receives hits and which vendor tags run is decided in
// the container by hostname, so production and preview ask for the same thing.
export const gtmFor = (deploy: string | undefined) =>
  deploy === 'production' || deploy === 'preview'
    ? { gtmId: 'GTM-KQLCFMF' }
    : null

const gtm = gtmFor(process.env.NEXT_PUBLIC_VERCEL_ENV)

// GTM takes the head script's default, Branch reads the cookie at init. A
// consent decision reloads the page; nothing syncs in-session.
export const MeasurementTags = () => (
  <>
    <Analytics />
    <SpeedInsights />
    {gtm && <GoogleTagManager {...gtm} />}
    {BRANCH_KEY && (
      <Script
        src="https://cdn.branch.io/branch-latest.min.js"
        onLoad={() =>
          window.branch.init(
            BRANCH_KEY,
            {
              no_journeys: true,
              tracking_disabled: !readEffectiveConsent().advertising,
            },
            (err) => {
              if (err) console.warn('Branch init failed', err)
            },
          )
        }
      />
    )}
  </>
)
